import { Transfer } from './Transfer';

export enum TransferMotion {
	COPY,
	MOVE,
}

// ???
// should this be called TransferBoard, and also should Motion be TransferMotion?
// I originally had those longer names but decided to abbreviate as it because
// I was sseeing "transfer" everywhere and it was getting a bit much
export class TransferBoard {
	constructor(public transfers: Transfer[] = [], public motion: TransferMotion) {
		// console.debug('new TransferBoard', this);
	}

	clear() {
		this.transfers = [];
	}
}
